<button
  (click)="buttonClick.emit()"
  [ngClass]="buttonClass || ''"
  mat-flat-button
  class="panel-button"
  >
  <div class="icon-container">
    @if (icon) {
      <fa-duotone-icon [icon]="icon" [ngClass]="iconClass || ''"></fa-duotone-icon>
    }
  </div>

  <span class="button-label">
    <ng-content></ng-content>
  </span>
</button>
